(function () {
  function carouselVertical() {
    const carouselVerticalElements = document.getElementsByClassName('carousel_vertical')
    for (let i = 0; i < carouselVerticalElements.length; i++) {
      const carouselVerticalItems = carouselVerticalElements[i].getElementsByClassName('carousel_vertical-item')

      let timeoutid = -1
      function carouselVerticalautoswipter() {
        clearTimeout(timeoutid)
        const carouselVerticalItemsLength = carouselVerticalItems.length
        let temp = 0
        for (let j = 0; j < carouselVerticalItemsLength; j++) {
          if (carouselVerticalItems[j].dataset.hover) temp = j
          delete carouselVerticalItems[j].dataset.hover
        }
          temp = (temp === carouselVerticalItemsLength - 1)?0:temp +1
          carouselVerticalItems[temp].dataset.hover = true
          //切换图片的显示
          let targetElement = carouselVerticalItems[temp]
          if (targetElement.className !== 'carousel_vertical-item') {
            targetElement = targetElement.parentNode || targetElement.parentElement
            if (targetElement.className !== 'carousel_vertical-item') {
              targetElement = targetElement.parentNode || targetElement.parentElement
            }
          }
          // 设置图片
          const imgUrl = targetElement.dataset.img
          imgElement.style.background = 'url(' + imgUrl + ') no-repeat center center'
          imgElement.style.backgroundSize = 'contain'

          timeoutid = setTimeout(carouselVerticalautoswipter, 5000)
      }
      if (carouselVerticalItems[0] && typeof carouselVerticalItems[0].dataset.single === 'string') {
        return
      }

      const imgElement = carouselVerticalElements[i].querySelector('.carousel_vertical-col > .img')
      for (let j = 0; j < carouselVerticalItems.length; j++) {
        // 当鼠标移入某一项中时，切换图片的显示
        function mοuseοverHandle(event) {
          carouselVerticalautoswipter()
          event.stopPropagation()
          let targetElement = event.target
          if (targetElement.className !== 'carousel_vertical-item') {
            targetElement = targetElement.parentNode || targetElement.parentElement
            if (targetElement.className !== 'carousel_vertical-item') {
              targetElement = targetElement.parentNode || targetElement.parentElement
            }
          }
          // 重置hover标记
          for (let k = 0; k < carouselVerticalItems.length; k++) {
            delete carouselVerticalItems[k].dataset.hover
          }
          targetElement.dataset.hover = true
          // 设置图片
          const imgUrl = targetElement.dataset.img
          imgElement.style.background = 'url(' + imgUrl + ') no-repeat center center'
          imgElement.style.backgroundSize = 'contain'
        }
        carouselVerticalItems[j].addEventListener('mouseenter', debounce(mοuseοverHandle, 100))
        carouselVerticalItems[j].addEventListener('touchstart', debounce(mοuseοverHandle, 100))
      }

      carouselVerticalautoswipter()
    }
  }
  
  carouselVertical()

})()